import React, { useEffect, useState } from "react";
import Header from "../../component/pages/Header";
import bagimage from "../../assets/paperbag.png"
// import lefimg from "../../assets/pink2.png";
// import righimg from "../../assets/pink1.png";
import { Colors, GOOGLE_API_KEY } from "../../common/Const";
// import chain1 from "../../assets/chain.png";
import "../mycartcomponent/Mycart.css";
import FavoriteBan from "../pages/FavoriteBan";
import Footer from "../pages/Footer";
import store from "../../redux/Store";
import { useSelector } from "react-redux";
import RemoveCartModule from "./RemoveCartModule";
import { ApiCall, Web_url } from "../../common/Const";
import { TailSpin } from "react-loader-spinner";
import { toast, ToastContainer } from "react-toastify";
import { useNavigate } from "react-router-dom";
import GuestLogin from "../auth/GuestLogin";
import { images } from "../../common/Images";

const Mycart = () => {
  const Redxcart = useSelector((state) => state.cart);
  const RedxPromo = useSelector((state) => state.promo);
  const LoginData = useSelector((state) => state.login);
  const navigate = useNavigate();
  const [activeValue, setActiveValue] = useState({});
  const [appSetting,setAppSetting] = useState([]);
  const [totalItem, setTotalItem] = useState(0);
  const [totalPrice, setTotalPrice] = useState(0);
  const [grandTotal, setGrandTotal] = useState(0);
  const [promoText, setPromoText] = useState("");
  const [currency, setCurrency] = useState("");
  const [error,setError] = useState(false);
  const [promoData,setPromoData] = useState("");
  const [promoValue,setPromoValue] = useState(0);
  const [PackingCharge,setPackingCharge] = useState(0);
  const [showLoading,setShowLoading] = useState(false);
  const [deliveryCharges,setDeliveryCharges] = useState(0);
  const [estimatedDeliveryDate,setestimatedDeliveryDate] = useState(0);
  const [ESTDate,setESTDate] = useState("");
  // const navigate = useNavigate();
  const decreaseQty = (value) =>{
    console.log(value,"value")
    if(value.quantity == 1){
      store.dispatch({
        type: "removeFromCart",
        payload: value,
      });
    }else{
      store.dispatch({
        type: "decreaseCount",
        payload: value,
      });
    }
  }
  const increaseQty = (value) =>{
    store.dispatch({
      type: "increaseCount",
      payload: value,
    });
  }
  const handleSetActive = (value) =>{
    setActiveValue(value);
  }
  function RupeesCal(amount) {
    return amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
  }

  console.log(Redxcart);
  useEffect(() =>{
    console.log(Redxcart,"Redxcarts")
    let count = 0;
    let total = 0;
    let taxTotal = 0;
    let packingCharge = 0;
    Redxcart.map((res)=>{
      count += res.quantity;
      total += res.order_price * res.quantity;
      packingCharge += res.packing_charges;
    })
    let taxvalue = 0;
    if(RedxPromo.promoValue){
      taxvalue = RedxPromo.promoValue;
      if(RedxPromo.discount_type ==2){
        let taxval = total * RedxPromo.promoDetails / 100;
        console.log(taxval,"taxval");
        setPromoValue(taxval);
        taxvalue = taxval;
      }
    }else{
      taxvalue = 0;
    }
    appSetting.map((res)=>{
      console.log(total-taxvalue,total,taxvalue,getAllByText(total-taxvalue,res.tax_value))
      taxTotal += getAllByText(total-taxvalue,res.tax_value);
    })
   
    setPackingCharge(packingCharge);
    console.log(total,taxTotal,packingCharge,deliveryCharges,taxvalue);
    setGrandTotal(total+taxTotal+packingCharge+deliveryCharges-taxvalue);
    setTotalItem(count);
    setTotalPrice(total);
  },[Redxcart,appSetting,promoValue,deliveryCharges])
  useEffect(()=>{
    Appsetting();
    Appsettings();
    if(RedxPromo.promoValue){
      setPromoData({
        discount_type : RedxPromo.discount_type,
        discount_percentage : RedxPromo.promoDetails
      });
      setPromoValue(RedxPromo.promoValue);
      setPromoText(RedxPromo.code)
    }
  },[])
  const Appsetting =()=>{
    ApiCall('checkTax', {}).then((data) => {
      console.log(data,"data")
        if (data.message === "Success") {
          setAppSetting(data.result)
        }
    }).catch(err => console.log(err));
  }
  const Appsettings =()=>{
    ApiCall('appsetting', {}).then((data) => {
      console.log(data,"AppSettings")
        if (data.message === "Success") {
          setDeliveryCharges(data.result.delivery_charges);
          setestimatedDeliveryDate(data.result.estimate_delivery_days);
          setCurrency(data.result.currency.symbol)
          // setAppSetting(data.result)
        }
    }).catch(err => console.log(err));
  }
  const getAllByText =(total,val) =>{
    let price = total * val /100; 
    return price;
  }
  const applayPromo =() =>{
    if(promoText.trim().length == 0){
      setError(true);
    }else{
      setShowLoading(true);
      setError(false);
      ApiCall('couponCheck', {coupon_code:promoText}).then((data) => {
        setShowLoading(false);
          if (data.message === "Success") {
            setPromoData(data.result)
            let promo_data = data.result;
            if(promo_data.discount_type == 1){
              //flat
              setPromoValue(promo_data.discount);
              store.dispatch({
                type: "addPromo",
                payload: { promoValue: promo_data.discount,promoDetails :  "Promo",discount_type:promo_data.discount_type,code:promo_data.coupon_code},
              });
            }else if(promo_data.discount_type == 2){
              //persentage
              let val = totalPrice * promo_data.discount_percentage / 100;
              setPromoValue(val);
              store.dispatch({
                type: "addPromo",
                payload: { promoValue: val,promoDetails :  promo_data.discount_percentage,discount_type:promo_data.discount_type,code:promo_data.coupon_code},
              });
            }else{

            }
            toast.success("Promocode Applied Succes", {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });

          }else if(data.message === "Expired Promocode"){
            toast.error(data.message, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });

          }else{
            toast.error(data.message, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
            setPromoValue(0);
          }
      }).catch(err => console.log(err));
    }
  }
  const handleChangePromo = (e) =>{
    setPromoText(e.target.value);
  }
  const removeCoupon = () =>{
    setPromoData("");
    setPromoValue(0);
    store.dispatch({
      type: "clearPromo",
      payload: { },
    });
  }
  const goToCheckOut = () =>{
    navigate("/checkout");
  }
  useEffect(()=>{
  },[appSetting])
  const moveToFilter = () =>{
    navigate("/filter");
  }

 const DateFormet = (data) => {

  const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "July", "Aug", "Sep", "Oct", "Nov", "Dec"
  ];
  const value = new Date(data)

  const day = value.getDate()
  const month = value.getMonth()
  const year = value.getFullYear()
  const fullformet = `${day}-${monthNames[month]}-${year}`
  setESTDate(fullformet);
  return fullformet;
}
useEffect(()=>{
  var someDate = new Date();
  var numberOfDaysToAdd = estimatedDeliveryDate;
  var result = someDate.setDate(someDate.getDate() + numberOfDaysToAdd);
  console.log(new Date(result))
  DateFormet(result);
},[estimatedDeliveryDate])
const moveToLogin = () =>{
  navigate("/login");
}
  return (
    <div className="my-cart">
      <ToastContainer />
      <Header make={true} />
      <div className="" style={{ backgroundColor: "#fff4f7" }}>
        {/* <FavoriteBan /> */}
        {/*prdouct-side */}
        <div className="container py-4">
          {
            Redxcart.length != 0 ? 
            <>
              <div className="row" style={{marginBottom:"20px"}}>
                <div className="col-md-3 col-sm-6 col-6">
                  <a href="javascript:history.go(-1)"><button className="btn cart-back" style={{background: Colors.Base_color,color:"white"}} ><img src={images.left} width={30}/><span style={{position: "relative",left: "-8px",top: "2px"}}> Back</span></button></a>
                </div>
                <div className="col-md-3 col-sm-6 col-6 mt-2">
                  <h4 className="title">My Cart</h4>
                </div>
              </div>
          <div className="row" style={{ marginRight: "0px" }}>
            <div className="col-12 col-xxl-7 col-xl-7 col-lg-6 col-md-6 col-12 left-side">
              <div className="d-flex flex-column gap-3">
                <div>
                  <div className="total-items">
                  <RemoveCartModule value={activeValue} />
                {Redxcart.map((values) => {
                  return (
                    <>
                      <div className="cart-items">
                        <i
                          class="fa-solid fa-xmark"
                          style={{
                            position: "absolute",
                            right: "0px",
                            cursor: "pointer",
                            fontSize: "25px",
                            color: "gray",
                          }}
                          onClick={() => {
                            handleSetActive(values);
                          }}
                          data-bs-toggle="modal"
                          data-bs-target="#removeCart"
                        ></i>
                        <div className="d-flex gap-4 mb-3">
                          <div className="smallimage d-flex justify-content-center">
                            <img
                              src={
                                values.product_image
                                  ? Web_url.Domain_url +
                                    values.product_image[0].url
                                  : null
                              }
                              className="order-image"
                            ></img>
                          </div>
                          <div className="details">
                            <h3 className="prdt-title">
                              {values.product_name}
                            </h3>
                            <h4 className="original_rate" style={{paddingBottom:"0px"}}>
                              Rs.{currency} {values.order_price}
                            </h4>
                            <div>
                              {/* <small> 
                                Karat - {values.karat}k, Size - {values.order_sizes}mm
                              </small> */}
                            </div>
                            <div className="orders-text d-flex ">
                              <h5 className="gram" style={{top: "5px",position: "relative"}}>{values.varient}</h5>
                              <div className="buttons ">
                                <small
                                  className="butn1"
                                  style={{ cursor: "pointer" }}
                                  onClick={() => {
                                    decreaseQty(values);
                                  }}
                                >
                                  <span>-</span>
                                </small>
                                <small className="quantitys">
                                  <span>{values.quantity}</span>
                                </small>
                                <small
                                  className="butn1"
                                  style={{ cursor: "pointer" }}
                                  onClick={() => {
                                    increaseQty(values);
                                  }}
                                >
                                  <span>+</span>
                                </small>
                              </div>
                            </div>
                          </div>
                        </div>
                        <hr
                          style={{ width: "100%", borderTop: "2px solid" }}
                        ></hr>
                      </div>
                    </>
                  );
                })}
                  </div>
                {/* <div className="estimated d-flex">
                  <h5 className="est">
                    Estimate Delivery Time(EDT){" "}
                    <small className=" pe-2">{estimatedDeliveryDate} Days</small>
                  </h5>
                  <h5>{ESTDate}</h5>
                </div> */}
                </div>

                
              </div>
            </div>
            <div className="col-7 col-xxl-4 col-xl-5 col-lg-6 col-md-6 col-12 rig-co">
              <div className="right-side">
                <div className="estimated d-flex">
                  <h5 className="est">
                  {/* Estimate Delivery Time (15 days)  26-Jan-22 */}
                    Estimate Delivery Time
                    <small className=" pe-2">({estimatedDeliveryDate} Days)</small>
                  </h5>
                  <h5>{ESTDate}</h5>
                </div>
                <h4 className="itemsanddtls">Item & Price Details</h4>
                <div className="d-flex flex-column">
                  <div className="details d-flex gap-4">
                    <div className="no-itmes">
                      <h5>No of Items</h5>
                      <h5>Items of Total</h5>
                      {appSetting.map((res) => {
                        return (
                          <h5>
                            {res.tax_name}({res.tax_value} %)
                          </h5>
                        );
                      })}
                      <h5>Packing charge</h5>
                      <h5>Delivery Charges</h5>
                      {promoValue != 0 ? (
                        <h5>
                          Promo{" "}
                          {promoData.discount_type == 2
                            ? "(" + promoData.discount_percentage + " %)"
                            : null}
                        </h5>
                      ) : null}
                      <h5 className="grand-total">Grand Total</h5>
                    </div>

                    <div className="no-itmes">
                      <h5>:</h5>
                      <h5>:</h5>
                      {appSetting.map((res) => {
                        return <h5>:</h5>;
                      })}
                      <h5>:</h5>
                      <h5>:</h5>
                      {promoValue != 0 ? <h5>:</h5> : null}
                      <h5 className="grand-total">:</h5>
                    </div>
                    <div className="rates">
                      <h5>{totalItem}</h5>
                      <h5>{currency} {RupeesCal(totalPrice)}</h5>
                      {appSetting.map((res) => {
                        return <h5>{currency} {getAllByText(totalPrice-promoValue,res.tax_value).toFixed(2)}</h5>;
                      })}
                      <h5>{currency} {RupeesCal(PackingCharge)}</h5>
                      <h5>{currency} {RupeesCal(deliveryCharges)}</h5>
                      {promoValue != 0 ? <h5>{currency}  -{RupeesCal(promoValue)}</h5> : null}
                      <h5 className="grand-total">{currency} {RupeesCal(grandTotal.toFixed(2))}</h5>
                    </div>
                  </div>
                  <div className="promo-code row pt-5">
                    <div className="col-xs-7 col-sm-7 col-md-7 col-lg-7 col-6 mid-col">
                      <div
                        className="form-group apply-promo"
                        style={{ position: "relative" }}
                      >
                        {promoValue != 0 ? (
                          <button
                            class="btn btn-dark remove_btn"
                            onClick={removeCoupon}
                          >
                            Remove
                          </button>
                        ) : null}
                        <input
                          type="search"
                          name="search_menu"
                          id="search_menu"
                          class="form-control"
                          placeholder="Apply Promo Code"
                          readOnly={promoValue == 0 ? false : true}
                          onChange={(e) => {
                            handleChangePromo(e);
                          }}
                          defaultValue={promoText}
                        />
                      </div>
                    </div>
                    <div className="col-xs-2 col-sm-5 col-md-4 col-lg-4 col-4 end-col">
                      <div className="form-group">
                        <button
                          type="button"
                          name="search_menu_btn"
                          id="search_menu_btn"
                          class="btn btn-sm btn-default"
                          style={{
                            background: promoValue != 0 ? "green" : "#126a38",
                          }}
                          disabled={
                            showLoading ? true : promoValue != 0 ? true : false
                          }
                          onClick={applayPromo}
                        >
                          {showLoading ? (
                            <TailSpin
                              height="35"
                              width="35"
                              color="white"
                              ariaLabel="tail-spin-loading"
                              radius="1"
                              wrapperStyle={{ justifyContent: "center" }}
                              wrapperClass=""
                              visible={true}
                            />
                          ) : promoValue == 0 ? (
                            "Apply"
                          ) : (
                            "Applied"
                          )}
                        </button>
                        <input type="hidden" name="apply" id="apply" />
                      </div>
                    </div>
                    {error ? (
                      <p className="promo-err text-danger m-1">Enter Promo Code</p>
                    ) : null}
                  </div>
                </div>
              </div>
              <GuestLogin />
              { 
              LoginData.id ? null : 
                <div className="row logbtn-parent justify-content-center" style={{marginTop:"20px"}}>
                  <div className="col-lg-6 col-md-12 col-sm-12 col-10 logButtonLeft mt-2" >
                    <button className="btn btn-basic guestBtn" style={{background: Colors.Base_color,color:"white"}} onClick={moveToLogin}>Login</button>
                  </div>
                  <div className="col-lg-6 col-md-12 col-sm-12 col-10 logButton mt-2">
                    <button className="btn btn-basic guestBtn"  data-bs-toggle="modal"
                          data-bs-target="#guestLogin" style={{background: Colors.Base_color,color:"white"}}>Checkout as Guest</button>
                  </div>
                </div>
              }
              <div className="mt-4 ">
                <div className="proceed-check ">
                  <button
                    type="button"
                    className="btn checkout "
                    onClick={goToCheckOut}
                    disabled={LoginData.id ? false : true}
                  >
                    Proceed & Checkout
                  </button>
                </div>
              </div>
            </div>
          </div>
          </>
          :
          <div className="text-center mb-5">
            <img src={bagimage} width={150}/>
            <h1>Your Shopping Bag is Empty!!</h1>
            <p>There is nothing in your bag. Keep adding items now!</p>
            <button
                type="button"
                className="btn show-btn py-2 px-4 rounded"
                style={{ color: Colors.white_color, backgroundColor: Colors.Base_color }}
                onClick={moveToFilter}
            >START SHOPPING</button>
          </div>
          
          }
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Mycart;
